import React from "react"

import { styled } from "@mui/material"

const StyledFooter = styled("footer", {
})(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(10),
    "& .site-footer-logo": {
      display: "block",
      height: 24,
      left: "50%",
      marginLeft: -22.5,
      objectFit: "cover",
      position: "absolute",
      top: -24,
      width: 45
    },
    [theme.breakpoints.up("sm")]: {
      "& .site-footer-logo": {
        marginLeft: -250,
        width: 500
      }
    }
  }
})

const Footer = (props) => {
  return (
    <StyledFooter className="site-footer">
      {props.children}
    </StyledFooter>
  )
}

export default React.memo(Footer)